import PropTypes from 'prop-types';
import { withApollo } from '@apollo/client/react/hoc';
import { Formik } from 'formik';
import compose from 'lodash/flowRight';
import NewCommentForm, { newCommentSchema } from './new-comment-form';
import { createEventCommentMutation, eventCommentsQuery } from '../../apollo/events';
import consumeAppContext from '../../consumers/app';
import { processMutationError } from '../../utils/formik';
import LoginRequiredNotice from '../login-required-notice';

const NewEventComment = ({ client, event, disabled, isLoggedIn }) => {
  if (!isLoggedIn) {
    return (
      <LoginRequiredNotice
        returnTo={`/events/${event.id}`}
        action="comment"
        compact
      />
    );
  }

  if (event.status !== 'PUBLISHED') {
    return (
      <p>Comments are disabled because event is not yet published.</p>
    );
  }

  return (
    <Formik
      initialValues={{
        body: null
      }}
      validationSchema={newCommentSchema}
      onSubmit={async (values, actions) => {
        client.mutate({
          mutation: createEventCommentMutation,
          variables: {
            eventId: event.id,
            data: values,
          },
          update: (proxy, { data: { createEventComment: newComment } }) => {
            const eventCommentsVariables = { eventId: event.id };
            const data = proxy.readQuery({
              query: eventCommentsQuery,
              variables: eventCommentsVariables,
            });
            proxy.writeQuery({
              query: eventCommentsQuery,
              data: {
                ...data,
                event: {
                  ...data.event,
                  comments: [...data.event.comments, newComment],
                  commentCount: data.event.commentCount + 1,
                },
              },
              variables: eventCommentsVariables,
            });
          },
        }).then(() => {
          actions.setSubmitting(false);
          actions.resetForm();
        }).catch((error) => {
          processMutationError(error, actions);
        });
      }}
    >
      {(props) => (
        <NewCommentForm
          {...props}
          disabled={disabled}
          name={`new-event-comment-${event.id}`}
        />
      )}
    </Formik>
  );
}

NewEventComment.propTypes = {
  event: PropTypes.object,
  disabled: PropTypes.bool,
  client: PropTypes.object,
  isLoggedIn: PropTypes.bool
};

export default compose(
  withApollo,
  consumeAppContext
)(NewEventComment);
